import { render, staticRenderFns } from "./deleteOwnerInvoice.vue?vue&type=template&id=e5a12d0e"
import script from "./deleteOwnerInvoice.vue?vue&type=script&lang=js"
export * from "./deleteOwnerInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports